var Facility = /** @class */function () {
  function Facility(data) {
    this.id = data.id;
    this.features = data.features;
    this.featureTexting = data.featureTexting;
    this.visitationSchedulingEnabled = stringToBoolean((data.visitationSchedulingEnabled || 'false').toString());
    this.configurations = Array.isArray(data.configurations) ? data.configurations : [];
    this.name = data.name;
    this.address = data.address;
    this.city = data.city;
    this.state = data.state;
    this.zip = data.zip;
    this.timezone = data.timezone;
    this.communicationsEnabled = data.communicationsEnabled;
    this.textingLocalStatus = data.textingLocalStatus;
    this.audioCallingEnabled = data.audioCallingEnabled;
    this.videoCallingEnabled = data.videoCallingEnabled;
    this.referenceMaterialEnabled = data.referenceMaterialEnabled;
    this.musicEnabled = data.musicEnabled;
    this.itdsMode = data.itdsMode;
    this.housingUnits = data.housingUnits;
  }
  Facility.prototype.getConfigurationValue = function (key) {
    var matches = this.configurations.filter(function (c) {
      return c.key.toLowerCase() == key.toLowerCase();
    });
    if (matches.length > 0) {
      return matches[0].value;
    }
    return null;
  };
  return Facility;
}();
export { Facility };
function stringToBoolean(val) {
  switch (val.toLowerCase()) {
    case 'true':
    case '1':
      return true;
    default:
      return false;
  }
}